export default __webpack_public_path__ + "static/media/ATR150.ba185a5f.png";